import React from 'react';
import PropTypes from 'prop-types';
import { getVdpPfButtonText } from 'site-modules/shared/utils/inventory/get-vdp-pf-button-text';

import './photo-count-badge.scss';

export function PhotoCountBadge({ photoCount }) {
  return (
    <div
      className="photo-count-badge btn-responsive btn d-flex align-items-center text-cool-gray-30 fw-bold mx-0_5 mt-0_5"
      style={{
        position: 'absolute',
        zIndex: 3,
        bottom: 0,
        left: 0,
        marginBottom: '0.75rem',
        border: '2px solid #e6e6e6',
      }}
    >
      <i className="icon-grid2 me-0_5" aria-hidden style={{ lineHeight: 1.25 }} />
      {getVdpPfButtonText({ photoCount })}
    </div>
  );
}

PhotoCountBadge.propTypes = { photoCount: PropTypes.number.isRequired };
